import React from 'react'

import useForm from 'react-hook-form'
import schemas from './../../../../schemas'

import { TextField, Box, Button, makeStyles } from '@material-ui/core'

import styles from './styles'
import { RHFInput } from 'react-hook-form-input'

const useStyles = makeStyles(styles)

const SettingsInvoiceForm = ({ settings, handleClose, onSubmit }) => {
  const classes = useStyles()

  const { register, setValue, errors, handleSubmit } = useForm({
    validationSchema: schemas.invoice,
    defaultValues: {
      contractOverdue: settings.contractOverdue.value,
      contractCancelOverdue: settings.contractCancelOverdue.value,
      contractCancelPending: settings.contractCancelPending.value,
      invoiceInterval: settings.invoiceInterval.value,
      paymentMaxSplit: settings.paymentMaxSplit.value,
      paymentDaysToGenerate: settings.paymentDaysToGenerate.value,
      invoicesGenerationOnOverdue: settings.invoicesGenerationOnOverdue.value,
      generateFirstInvoiceProportional:
        settings.generateFirstInvoiceProportional.value,
      generateProportionalOnOverdue:
        settings.generateProportionalOnOverdue.value,
      generateProportionalOnPause: settings.generateProportionalOnPause.value,
      generateProportionalOnDayExpirationChanges:
        settings.generateProportionalOnDayExpirationChanges.value,
      generateInvoiceWhenInactivated:
        settings.generateInvoiceWhenInactivated.value,
      generateProportionalOnUpgrade:
        settings.generateProportionalOnUpgrade.value,
      generateProportionalOnDowngrade:
        settings.generateProportionalOnDowngrade.value,
    },
  })

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classes.root}>
      <RHFInput
        as={
          <TextField
            type="number"
            margin="dense"
            label="Dias para definir uma assinatura como inadimplente por falta de pagamento"
            error={!!errors.contractOverdue}
            helperText={
              errors.contractOverdue && errors.contractOverdue.message
            }
            fullWidth
          />
        }
        register={register}
        setValue={setValue}
        name="contractOverdue"
      />
      <RHFInput
        as={
          <TextField
            type="number"
            margin="dense"
            label="Dias para cancelar uma assinatura após inadimplência"
            error={!!errors.contractCancelOverdue}
            helperText={
              errors.contractCancelOverdue &&
              errors.contractCancelOverdue.message
            }
            fullWidth
          />
        }
        register={register}
        setValue={setValue}
        name="contractCancelOverdue"
      />
      <RHFInput
        as={
          <TextField
            type="number"
            margin="dense"
            label="Dias para cancelar uma assinatura por falta de primeiro pagamento"
            error={!!errors.contractCancelPending}
            helperText={
              errors.contractCancelPending &&
              errors.contractCancelPending.message
            }
            fullWidth
          />
        }
        register={register}
        setValue={setValue}
        name="contractCancelPending"
      />
      <RHFInput
        as={
          <TextField
            type="number"
            margin="dense"
            label="Dias para geração da fatura antes do vencimento da assinatura"
            error={!!errors.invoiceInterval}
            helperText={
              errors.invoiceInterval && errors.invoiceInterval.message
            }
            fullWidth
          />
        }
        register={register}
        setValue={setValue}
        name="invoiceInterval"
        mode="onChange"
      />
      <RHFInput
        as={
          <TextField
            type="number"
            margin="dense"
            label="Número de parcelas permitido na fatura quando paga com cartão de crédito"
            error={!!errors.paymentMaxSplit}
            helperText={
              errors.paymentMaxSplit && errors.paymentMaxSplit.message
            }
            fullWidth
          />
        }
        register={register}
        setValue={setValue}
        name="paymentMaxSplit"
      />
      <RHFInput
        as={
          <TextField
            type="number"
            margin="dense"
            label="Dias para o vencimento da primeira fatura a partir da contratação"
            error={!!errors.paymentDaysToGenerate}
            helperText={
              errors.paymentDaysToGenerate &&
              errors.paymentDaysToGenerate.message
            }
            fullWidth
          />
        }
        register={register}
        setValue={setValue}
        name="paymentDaysToGenerate"
      />
      <RHFInput
        as={
          <TextField
            margin="dense"
            label="Gerar fatura mesmo que inadimplente"
            variant="outlined"
            error={!!errors.invoicesGenerationOnOverdue}
            helperText={
              errors.invoicesGenerationOnOverdue &&
              errors.invoicesGenerationOnOverdue.message
            }
            SelectProps={{ native: true }}
            select
            fullWidth
          >
            <option value=""></option>
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </TextField>
        }
        register={register}
        setValue={setValue}
        name="invoicesGenerationOnOverdue"
      />
      <RHFInput
        as={
          <TextField
            margin="dense"
            label="Primeira fatura proporcional"
            variant="outlined"
            error={!!errors.generateFirstInvoiceProportional}
            helperText={
              errors.generateFirstInvoiceProportional &&
              errors.generateFirstInvoiceProportional.message
            }
            SelectProps={{ native: true }}
            select
            fullWidth
          >
            <option value=""></option>
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </TextField>
        }
        register={register}
        setValue={setValue}
        name="generateFirstInvoiceProportional"
      />
      <RHFInput
        as={
          <TextField
            margin="dense"
            label="Proporcional em inadimplência"
            variant="outlined"
            error={!!errors.generateProportionalOnOverdue}
            helperText={
              errors.generateProportionalOnOverdue &&
              errors.generateProportionalOnOverdue.message
            }
            SelectProps={{ native: true }}
            select
            fullWidth
          >
            <option value=""></option>
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </TextField>
        }
        register={register}
        setValue={setValue}
        name="generateProportionalOnOverdue"
      />
      <RHFInput
        as={
          <TextField
            margin="dense"
            label="Proporcional em suspensão"
            variant="outlined"
            error={!!errors.generateProportionalOnPause}
            helperText={
              errors.generateProportionalOnPause &&
              errors.generateProportionalOnPause.message
            }
            SelectProps={{ native: true }}
            select
            fullWidth
          >
            <option value=""></option>
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </TextField>
        }
        register={register}
        setValue={setValue}
        name="generateProportionalOnPause"
      />
      <RHFInput
        as={
          <TextField
            margin="dense"
            label="Proporcional em mudança de dia de faturamento"
            variant="outlined"
            error={!!errors.generateProportionalOnDayExpirationChanges}
            helperText={
              errors.generateProportionalOnDayExpirationChanges &&
              errors.generateProportionalOnDayExpirationChanges.message
            }
            SelectProps={{ native: true }}
            select
            fullWidth
          >
            <option value=""></option>
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </TextField>
        }
        register={register}
        setValue={setValue}
        name="generateProportionalOnDayExpirationChanges"
      />
      <RHFInput
        as={
          <TextField
            margin="dense"
            label="Fatura proporcional em inativação e cancelamento"
            variant="outlined"
            error={!!errors.generateInvoiceWhenInactivated}
            helperText={
              errors.generateInvoiceWhenInactivated &&
              errors.generateInvoiceWhenInactivated.message
            }
            SelectProps={{ native: true }}
            select
            fullWidth
          >
            <option value=""></option>
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </TextField>
        }
        register={register}
        setValue={setValue}
        name="generateInvoiceWhenInactivated"
      />
      <RHFInput
        as={
          <TextField
            margin="dense"
            label="Proporcional em upgrade"
            variant="outlined"
            error={!!errors.generateProportionalOnUpgrade}
            helperText={
              errors.generateProportionalOnUpgrade &&
              errors.generateProportionalOnUpgrade.message
            }
            SelectProps={{ native: true }}
            select
            fullWidth
          >
            <option value=""></option>
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </TextField>
        }
        register={register}
        setValue={setValue}
        name="generateProportionalOnUpgrade"
      />
      <RHFInput
        as={
          <TextField
            margin="dense"
            label="Proporcional em downgrade"
            variant="outlined"
            error={!!errors.generateProportionalOnDowngrade}
            helperText={
              errors.generateProportionalOnDowngrade &&
              errors.generateProportionalOnDowngrade.message
            }
            SelectProps={{ native: true }}
            select
            fullWidth
          >
            <option value=""></option>
            <option value="0">Não</option>
            <option value="1">Sim</option>
          </TextField>
        }
        register={register}
        setValue={setValue}
        name="generateProportionalOnDowngrade"
      />

      <Box pt={2}>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          className={classes.btnSave}
        >
          Salvar
        </Button>
        <Button
          type="button"
          variant="outlined"
          color="primary"
          onClick={handleClose}
        >
          Cancelar
        </Button>
      </Box>
    </form>
  )
}

export default SettingsInvoiceForm
